import { Avatar, Text, Button, Paper } from '@mantine/core';
import {useNavigate} from 'react-router-dom'

interface UserInfoActionProps {
  avatar: string;
  name: string;
  email: string;
  job: string;
  link: string;
}

export function UserInfoAction({ avatar, name, email, job , link }: UserInfoActionProps) {
  const navigate = useNavigate();
  return (
    <Paper
      radius="md"
      withBorder
      p="lg"
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
      })}
    >
      <Avatar src={avatar} size={120} radius={120} mx="auto" />
      <Text ta="center" fz="lg" weight={500} mt="md">
        {name}
      </Text>
      <Text ta="center" c="dimmed" fz="sm">
        {email} • {job}
      </Text>

      <Button variant="default" fullWidth mt="md" onClick={()=>{
        navigate(link)
      }}>
        More Info
      </Button>
    </Paper>
  );
}